import { useTranslation } from 'react-i18next';

import TitleQuotation from '../../components/title-quotation';
import Hr from '../../components/Style/hr';
import ServicesSelection from '../../components/services-selection';

export default function StepListOfServices({ listOfServices, previouslySelectedServices, returnedData }) {
    const { t } = useTranslation();

    const handleReturnedData = (data) => {
        returnedData(data);
    };

    return (
        <>
            <TitleQuotation title={t('pageServices.step1.welcomeMessage')} description={t('pageServices.step1.description')} step="1" />
            <Hr />
            <ServicesSelection listOfServices={listOfServices} previouslySelectedServices={previouslySelectedServices} returnedData={handleReturnedData} />
        </>
    );
}